export { BvlSwitchValueComponent as BvlSwitchValue } from './switch-value.component';
export { BvlSwitchValueModule } from './switch-value.module';